import { useDispatch } from "react-redux";

import { resetFilters, setFilter } from "..";
import { PendingFilterKey, PendingFilterState } from "../types";

export const usePendingFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = <K extends PendingFilterKey>(payload: {
    key: K;
    value: PendingFilterState["filters"][K];
  }) => dispatch(setFilter(payload));

  const clearFilters = () => dispatch(resetFilters());

  return { updateFilter, clearFilters };
};
